import gql from 'graphql-tag';
const FILL_IN_THE_BLANKS_ACTIVITY_FRAGMENT = gql `
  fragment FillInTheBlanksActivityFragment on FillInTheBlanksActivity {
    rounds {
      roundIndex
      steps {
        stepIndex
        answer
        optionalAudio: audio
        prefix
      }
    }
  }
`;
export default FILL_IN_THE_BLANKS_ACTIVITY_FRAGMENT;
